import React from 'react'
import "./NewHolidayList.css"


function formatDate(dateString) {
    const date = new Date(dateString);
    const dayName = date.toLocaleString("default", { weekday: "short" }); // e.g., Mon, Tue
    const month = date.toLocaleString("default", { month: "short" }); // e.g., Jan, Feb
    const day = date.getDate(); // Numeric day of the month
    return `${dayName}, ${month} ${day}`;
}

const groupHolidaysByMonth = (holidays) => {
    const grouped = {};
    holidays.forEach((holiday) => {
        const start = new Date(holiday.startDate);
        const monthYear = start.toLocaleString('default', { month: 'long', year: 'numeric' });
        if (!grouped[monthYear]) {
            grouped[monthYear] = [];
        }

        grouped[monthYear].push(holiday);
    });

    return grouped;
};


function NewHolidaysList({ holidays, setListHolidays }) {
    const groupedHolidays = groupHolidaysByMonth(holidays);
    return (
        <div className='container_holidays'>
            <img
                style={{ position: "absolute", top: "14%", left: "64%" }}
                src="./images/cross.png"
                className=" rounded-circle"
                alt=""
                onClick={(e) => setListHolidays(false)}
            />
            <div className="holiday-viewer">
                <h2>Holiday Calendar</h2>
                <div className='holiday-viewer-child'>
                    {Object.keys(groupedHolidays).map((monthYear) => (
                        <div key={monthYear} className="month-section">
                            <h3 className="month-title">{monthYear}</h3>
                            <ul className="holiday-list">
                                {groupedHolidays[monthYear].map((holiday, index) => (
                                    <li key={index} className="holiday-item">
                                        <div className="holiday-date">
                                            {holiday.startDate === holiday.endDate
                                                ? formatDate(holiday.startDate)
                                                : `${formatDate(holiday.startDate)} - ${formatDate(holiday.endDate)}`}
                                        </div>
                                        <div className="holiday-name">{holiday.name}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default NewHolidaysList